module.exports = "<dx-button text=\"Press me\" ></dx-button>\n\n"